
<template>
  <table class="tw-table w-full">
    <thead class="tw-thead">
      <tr class="tw-tr">
        <th class="tw-th"></th>
        <th class="tw-th text-center!" v-for="value in field.datahash.options.values">
          {{$tr(value, 'label')}}
        </th>
        <th class="tw-th text-center!" v-if="field.datahash.comments">
          {{$tr(field.datahash, 'comments_label') || 'Comments'}}
        </th>
      </tr>
    </thead>

    <tbody class="tw-tbody">
      <tr class="tw-tr" v-for="statement in field.datahash.statements">
        <td class="tw-td">
          <div class="whitespace-normal">
            {{$tr(statement, 'label')}}
          </div>
        </td>
        <td class="tw-td align-center content-center" v-for="value in field.datahash.options.values">
          <likert-answer-option-display
              :field="field"
              :statement="statement"
              :value="value"
              :disabled="true"
          />
        </td>
        <td class="tw-td-word-wrap" v-if="field.datahash.comments">
          <likert-answer-comment-display
              :field="field"
              form-id="1"
              :statement="statement"
          />
        </td>
      </tr>
    </tbody>
  </table>

</template>
<script>
import mixin from './_mixin_display'
import LikertAnswerCommentDisplay from './likert_answer_comment_display.vue';
import LikertAnswerOptionDisplay from './likert_answer_option_display.vue';
import LikertFieldComment from "./likert_field_comment_edit.vue";
import LikertFieldOption from "./likert_field_option_edit.vue";
export default {
  components: {LikertFieldOption, LikertFieldComment, LikertAnswerCommentDisplay, LikertAnswerOptionDisplay},
  mixins: [mixin],
  props: {
    value: {},
    index: {},
  },
  skipBasic: true,
  computed: {
  },
  created () {
  },
  methods: {
  }
}
</script>